import React, { ReactElement } from 'react';
import { ColumnInstance, Row } from 'react-table';

import { Dropdown, Loader } from 'ui/patterns';
import { Button } from 'ui/components';

import { useDeleteQuestions } from 'hooks';

import * as Icon from 'assets/icons';

import { confirmAlert } from 'utils/confirm-alert';
import { showSuccessToast, showErrorToast } from 'utils/showToast';

import { tableQuestionOptionProp } from './questionTypes';

export default function TableHeader(
  props: tableQuestionOptionProp,
): ReactElement {
  const questionId = props.row.original.Id;

  const { mutate: deleteQuestions, isLoading } = useDeleteQuestions();

  const questionListOptions = [
    {
      value: 'Edit Question',
      icon: <Icon.Edit title="" ariaHidden="true" />,
      groupEnd: true,
      action: () => props.onEditPress && props.onEditPress(questionId),
    },
    {
      value: 'Delete Question',
      icon: <Icon.Delete title="" ariaHidden="true" />,
      action: () => handleDeleteQuestion(),
    },
  ];

  const handleDeleteQuestion = () => {
    confirmAlert({
      message: 'Are you sure you want to delete this question?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            deleteQuestions(questionId, {
              onSuccess: () => {
                showSuccessToast({
                  message: 'Question has been deleted successfully.',
                });
              },
              onError: () => {
                showErrorToast({
                  message: 'This question is already used in a form',
                });
              },
            });
          },
          className: 'pr-btn-primary',
        },
        {
          label: 'No',
          onClick: () => {
            //
          },
        },
      ],
    });
  };

  const questionListDropdown = () => (
    <Button size="sm">
      <Icon.DotsVertical title="Options" />
    </Button>
  );

  return (
    <>
      <Dropdown
        trigger={questionListDropdown()}
        menuList={questionListOptions}
        position="left-top"
        className="dd-listitem-options"
      />
      {isLoading && <Loader />}
    </>
  );
}
